<script setup lang="ts">

import NewsNotificationDevices from '@/components/Sections/News/Notifications/Devices/NewsNotificationDevices.vue'
import NewsNotificationsBlocked from '@/components/Sections/News/Notifications/NewsBlocked/NewsNotificationsBlocked.vue'
</script>

<template>
 <div class="flex flex-col md:flex-row pt-1 w-full xl:w-2/3 2xl:w-1/2 mx-auto px-2 md:px-0">
   <div class="w-full md:w-1/2 ps-0 md:ps-2">
    <NewsNotificationDevices/>
   </div>
   <div class="w-full md:w-1/2 px-0 md:px-2">
    <NewsNotificationsBlocked/>
   </div>
 </div>
</template>

<style scoped lang="scss">

</style>